import styled, { StyledComponentClass } from 'styled-components';
import { Button, Paragraph, ITheme } from '@lce/slice-ui';
import { mediaQueries } from '@lce/slice-ui/variables';

import SafeLink from '../components/SafeLink';
import LcMascotGift from '../assets/svg/lc-mascot-gift.svg';
import { ISafeLinkProps } from '../components/SafeLink/SafeLink';

// TODO: Refactor safelink, accept inline prop?
export const InlineSafeLink: StyledComponentClass<ISafeLinkProps, ITheme> = styled(SafeLink)`
  display: inline-block;
`;

export const Mascot = styled(LcMascotGift)`
  display: block;
  width: 200px;

  @media ${mediaQueries.medium} {
    width: 280px;
    height: 225px;
  }

  @media ${mediaQueries.large} {
    width: 360px;
    height: 290px;
  }
`;

export const CtaButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.white};
  border-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.black};
  border-radius: 8px;

  :hover {
    background-color: ${(props) => props.theme.colors.white};
    border-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.black};
  }

  :active {
    background-color: ${(props) => props.theme.colors.white};
    border-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.black};
  }
`;

export const BannerMessage = styled.div`
  margin-bottom: 16px;
  text-align: center;

  @media ${mediaQueries.medium} {
    margin-bottom: 32px;
    text-align: left;
  }
`;

export const BannerParagraph = styled(Paragraph)`
  text-align: left;
`;
